import { TFunction } from 'client/i18n/hooks/useT';
import { EpisodeAudios } from 'modules/AnchorAPI/v3/episodes/fetchEpisodeOverview';

export const isVideoFile = (file: File) => !!file.type.match(/video/i);

export const calculateTotalDuration = (episodeAudios: EpisodeAudios[]) => {
  return episodeAudios.reduce((totalDuration, audio) => {
    return totalDuration + audio.duration;
  }, 0);
};

export const calculateAggregateDuration = (episodeAudios: EpisodeAudios[]) => {
  let sum = 0;
  return episodeAudios.map(audio => {
    sum = (sum || 0) + audio.duration / 1000;
    return sum;
  });
};

export const getMediaPlayerTitle = (
  episodeAudios: EpisodeAudios[],
  t: TFunction,
  title?: string
) => {
  // Return episode title if available
  if (title) return title;

  const DEFAULT_TITLE = t(
    'EpisodeOptionsScreen.EpisodeContent.UntitledAudio',
    'Untitled',
    'Untitled audio label'
  );

  // If episode has one audio/video return
  // caption if available, otherwise return default
  if (episodeAudios.length === 1) {
    return episodeAudios[0].caption || DEFAULT_TITLE;
  }

  // If episode has multiple audios but no title
  // return default
  return DEFAULT_TITLE;
};
